import { IDataUrl } from "@/manager/utils";
import SearchInput, { ISearchInputProps } from "./search-input";
import { useContext, useEffect, useState } from "react";
import useHttp from "@/shared/hooks/use-http";
import { getAllData } from "@/shared/utils/api";
import { AuthContext } from "@/shared/context/auth-context";

interface IAsyncSearchInputProps extends ISearchInputProps {
  url: IDataUrl;
}

const AsyncSearchInput = ({
  inputKey,
  url,
  onFocusEmpty,
  required,
  readonly,
  label,
  data,
  selectedOption,
  handleOnChange
}: IAsyncSearchInputProps) => {
  const authCtx = useContext(AuthContext);
  const [enumerationOptions, setEnumerationOptions] = useState(data)

  const { sendRequest: getData, status: getDataStatus, data: getDataData,  error: getDataError } = useHttp(
    getAllData,
    false,
    authCtx.token,
    url.transformType,
    url.backend);

  useEffect(() => {
    getData(url.url, undefined, undefined, "none");
  }, []);

  useEffect(() => {
    if (getDataStatus === "completed" && !getDataError && getDataData) {
      const transformedData = getDataData.rows.map((item: any) => ({ // eslint-disable-line
        id: item.id,
        name: item.name
      }));
      setEnumerationOptions(transformedData);
    }
  }, [getDataStatus, getDataData, getDataError]);

  return <div className="asyncSearchInput">
    <SearchInput 
      inputKey={inputKey}
      handleOnChange={handleOnChange}
      label={label}
      required={required}
      readonly={readonly}
      data={enumerationOptions}
      selectedOption={selectedOption}
      onFocusEmpty={onFocusEmpty} />
  </div>;
};

export default AsyncSearchInput;